import type { FC, ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

const LeftNavCollapseDisabledContext = createContext(false);

interface LeftNavCollapseDisabledProviderProps {
  readonly children: ReactNode;
}

/**
 * Disables the collapsed left nav within its subtree, forcing the navigation to render fully expanded
 * regardless of the persisted collapse preference or the current viewport width. Used when the left nav
 * is rendered inside a full-screen overlay where collapsing is not applicable.
 */
export const LeftNavCollapseDisabledProvider: FC<LeftNavCollapseDisabledProviderProps> = ({ children }) => (
  <LeftNavCollapseDisabledContext.Provider value={true}>{children}</LeftNavCollapseDisabledContext.Provider>
);

export const useIsLeftNavCollapseDisabled = (): boolean => useContext(LeftNavCollapseDisabledContext);
